import { render, staticRenderFns } from "./YzUploadButton.vue?vue&type=template&id=a456296c&scoped=true&lang=pug&"
import script from "./YzUploadButton.vue?vue&type=script&lang=js&"
export * from "./YzUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./YzUploadButton.vue?vue&type=style&index=0&id=a456296c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a456296c",
  null
  
)

export default component.exports